import toErrorWithMessage from 'utilities/getErrorMessage';
import request from './index';
import {
  IPatchExecutionProgressTracking,
  IExecutionProgressTrackingRequest,
  IExecutionProgressTrackingsRequest
} from 'types/executionProgressTrackings';

export const getExecutionProgressTrackings = () => {
  try {
    return request<IExecutionProgressTrackingsRequest>({
      options: {
        url: `/execution_progress_trackings`,
        method: 'get'
      },
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  } catch (e) {
    return { data: [], error: toErrorWithMessage(e) };
  }
};

export const patchExecutionProgressTracking = (
  id: number,
  data: IPatchExecutionProgressTracking
) => {
  try {
    return request<IExecutionProgressTrackingRequest>({
      options: {
        url: `/execution_progress_trackings/${id}`,
        method: 'patch',
        data: data
      }
    });
  } catch (e) {
    return { data: null, error: toErrorWithMessage(e) };
  }
};
